import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { MotionConfig, motion } from 'framer-motion';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Marquee from './components/Marquee';
import About from './components/About';
import Services from './components/Services';
import WhyUs from './components/WhyUs';
import History from './components/History';
import Gallery from './components/Gallery';
import References from './components/References';
import ContactDetails from './components/ContactDetails';
import Footer from './components/Footer';
import MachinesPage from './components/MachinesPage';
import { ScrollManager, ScrollProgress, SmoothScroll } from './components/SmoothScroll';
import { ConsentProvider } from './components/Consent';
import { MACHINE_CATEGORIES } from './data/machines';

const Home = () => (
  <>
    <Hero />
    <Marquee />
    <About />
    <Services />
    <WhyUs />
    <History />
    <Gallery />
    <References />
    <ContactDetails />
  </>
);

const Pages = () => {
  const { pathname } = useLocation();
  return (
    // Krátké prolnutí při přechodu mezi stránkami
    <motion.main key={pathname} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
      <Routes>
        <Route path="/" element={<Home />} />
        {Object.entries(MACHINE_CATEGORIES).map(([key, cat]) => (
          <Route key={key} path={cat.path} element={<MachinesPage category={key} />} />
        ))}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </motion.main>
  );
};

const App = () => (
  <Router>
    <SmoothScroll>
      <MotionConfig reducedMotion="user">
        <ConsentProvider>
          <ScrollManager />
          <ScrollProgress />
          <Navbar />
          <Pages />
          <Footer />
        </ConsentProvider>
      </MotionConfig>
    </SmoothScroll>
  </Router>
);

export default App;
